import { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Box } from '@chakra-ui/layout';
import { useColorModeValue } from '@chakra-ui/color-mode';
import { useBreakpoint } from '@chakra-ui/media-query';
import { MOBILE_DEVICES } from './utils/constants';
import About from './Pages/About';
import Skills from './Pages/Skills';
import Contact from './Pages/Contact';
import Projects from './Pages/Projects';
import Header from './Components/Header';
import Home from './Components/Home';
import { BarLoader } from 'react-spinners';

const App = () => {
	const breakpoint = useBreakpoint();
	const isMobile = MOBILE_DEVICES.includes(breakpoint);
	if (isMobile) {
		document.title = 'Trey Burleson'
	}

	return (
		<Box
			p={{ base: 0, md: 5 }}
			background={useColorModeValue('gray.50', 'gray.800')}
			id='about'
		>
			<Header />
			<Suspense fallback={<BarLoader />}>
				{!isMobile ? (
					<Routes>
						<Route path='/' element={<About />} />
						<Route path='/skills' element={<Skills />} />
						<Route path='/contact' element={<Contact />} />
						<Route path='/projects' element={<Projects />} />
						<Route path='*' element={<div>NotFound</div>} />
					</Routes>
				) : (
					<Routes>
						<Route path='*' element={<Home />} />
					</Routes>
				)}
			</Suspense>
		</Box>
	);
};

export default App;
